<!--
  API Badge 组件
  负责显示API商务合作标识
-->
<template>
  <div class="api-badge" @click="$emit('click')">
    <span class="api-text">{{ isMobile ? 'TTS88' : '商务合作' }}</span>
    <span class="api-tag">API</span>
  </div>
</template>

<script setup lang="ts">
interface Props {
  isMobile?: boolean
}

withDefaults(defineProps<Props>(), {
  isMobile: false
})

defineEmits<{
  'click': []
}>()
</script>

<style scoped>
.api-badge {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 42px;
  padding: 0 16px 0 18px;
  background:
    linear-gradient(135deg, rgba(255, 255, 255, 0.96), rgba(232, 248, 255, 0.9)),
    linear-gradient(135deg, #f8fdff, #d8f3ff);
  border: 1px solid rgba(120, 207, 255, 0.4);
  border-radius: 999px;
  box-shadow:
    0 10px 24px rgba(33, 150, 243, 0.12),
    inset 0 1px 0 rgba(255, 255, 255, 0.95);
  cursor: pointer;
  transition: transform 0.22s ease, box-shadow 0.22s ease, border-color 0.22s ease, background 0.22s ease;
  user-select: none;
}

.api-badge:hover {
  transform: translateY(-1px);
  background:
    linear-gradient(135deg, #ffffff, #dff6ff),
    linear-gradient(135deg, #f6fcff, #c9efff);
  border-color: rgba(47, 178, 255, 0.58);
  box-shadow:
    0 14px 28px rgba(33, 150, 243, 0.18),
    inset 0 1px 0 rgba(255, 255, 255, 0.95);
}

.api-badge:focus-visible {
  outline: 2px solid var(--tts-primary);
  outline-offset: 2px;
}

.api-text {
  color: #24364b;
  font-size: 15px;
  font-weight: 700;
  line-height: 1;
  transition: color 0.3s ease;
}

.api-badge:hover .api-text {
  color: #1287d4;
}

.api-tag {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 34px;
  height: 24px;
  padding: 0 8px;
  background: linear-gradient(135deg, #38bdf8, #2f83ff);
  color: #ffffff;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 800;
  line-height: 1;
  box-shadow: 0 8px 16px rgba(47, 131, 255, 0.24);
}

@media (max-width: 768px) {
  .api-badge {
    min-height: 38px;
    padding: 0 12px;
    gap: 6px;
  }
  
  .api-text {
    font-size: 12px;
  }
  
  .api-tag {
    min-width: 30px;
    height: 22px;
    padding: 0 6px;
    font-size: 10px;
  }
}
</style>
